import React from 'react';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-conditions-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-24">
        <Link
          to="/"
          className="text-amber-700 hover:text-amber-800 font-medium mb-8 inline-block"
        >
          ← Back to Home
        </Link>
        
        <h1 className="text-5xl font-bold text-slate-900 mb-8">Terms & Conditions</h1>
        
        <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using the website of Tiller Kingsley Bale Associates 
              (tillerkingsleybaleassociates.com), you accept and agree to be bound by these Terms and Conditions. 
              If you do not agree to these terms, please do not use this website.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">2. Attorney-Client Relationship</h2>
            <p>
              Use of this website and communication through our contact forms initiates the process for establishing 
              an attorney-client relationship. An attorney-client relationship is formally established through a 
              written engagement agreement signed by both parties following an initial consultation. Once engaged, 
              Tiller Kingsley Bale Associates provides professional legal services as outlined in the engagement agreement.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">3. Legal Services</h2>
            <p>
              Tiller Kingsley Bale Associates provides professional legal representation and counsel across corporate law, 
              business transactions, intellectual property, immigration, and regulatory compliance. The information on this 
              website describes our practice areas and services. Specific legal advice requires consideration of your unique 
              facts and circumstances and will be provided through our formal engagement process.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">4. Confidentiality</h2>
            <p>
              While we maintain appropriate security measures for website communications, confidential or time-sensitive 
              information is best discussed through secure channels we provide to our clients. Once an attorney-client 
              relationship is established, all communications are protected by attorney-client privilege and handled with 
              the utmost confidentiality.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">5. Accuracy of Information</h2>
            <p>
              We strive to provide accurate and up-to-date information about our legal services and practice areas. 
              While laws and regulations change frequently, our attorneys stay current with legal developments to 
              provide you with the most relevant and effective legal representation.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">6. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, Tiller Kingsley Bale Associates shall not be liable for 
              any direct, indirect, incidental, consequential, or punitive damages arising from your use of 
              this website or reliance on information contained herein.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">7. External Links</h2>
            <p>
              This website may contain links to external websites. We are not responsible for the content, 
              accuracy, or practices of linked sites. The inclusion of any link does not imply endorsement by 
              Tiller Kingsley Bale Associates.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">8. Intellectual Property</h2>
            <p>
              All content on this website, including text, graphics, logos, and images, is the property of 
              Tiller Kingsley Bale Associates and protected by copyright and other intellectual property laws. 
              Unauthorized use is prohibited.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">9. Jurisdictional Issues</h2>
            <p>
              This website is operated from the United States. We make no representation that materials on this 
              website are appropriate or available for use in other locations. If you access this website from 
              other locations, you are responsible for compliance with local laws.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">10. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms and Conditions at any time. Changes will be effective 
              immediately upon posting to this website. Your continued use of the website after changes 
              constitutes acceptance of the modified terms.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">11. Governing Law</h2>
            <p>
              These Terms and Conditions shall be governed by and construed in accordance with the laws of the 
              jurisdiction in which Tiller Kingsley Bale Associates operates, without regard to conflict of 
              law principles.
            </p>
          </section>

          <section>
            <h2 className="text-3xl font-semibold text-slate-900 mb-4">12. Contact Information</h2>
            <p>
              If you have questions about these Terms and Conditions, please contact us at:
            </p>
            <p className="mt-4">
              <strong>Tiller Kingsley Bale Associates</strong><br />
              Email: info@tillerkingsleybaleassociates.com<br />
              Website: tillerkingsleybaleassociates.com
            </p>
          </section>

          <section className="border-t border-slate-200 pt-8 mt-12">
            <p className="text-sm text-slate-500">
              Last Updated: January 2026
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
